export const ttlockConfig = {
  credentials: {
    title: "TTLock configuration",
    subtitle: "Enter your TTLock account credentials",
    savedBadge: "Credentials saved",
    noneBadge: "No credentials",
    emailLabel: "Your TTLock account email",
    emailPlaceholder: "you@example.com",
    emailHelp: "The email you use to sign in to TTLock",
    passwordLabel: "Password",
    passwordPlaceholderSaved: "•••••••• (saved, optional to change)",
    passwordPlaceholder: "Your TTLock password",
    passwordHelpSaved: "You can leave it empty if you already have one saved.",
    passwordHelp: "Your TTLock account password.",
    testing: "Testing...",
    testConnection: "Test connection",
    saving: "Saving...",
    saveCredentials: "Save credentials",
  },
  selector: {
    title: "Lock selector for this property",
    subtitleBefore: "Select only the locks that apply to ",
    subtitleStrong: "this property",
    subtitleAfter: ".",
    selectedCount: "{count} selected | {count} selected",
    hintBefore: "Enter your credentials and press ",
    hintStrong: "Test connection",
    hintAfter: " to load your locks.",
    noneFound: "No locks found. Check your TTLock account.",
    placeholder: "Select locks…",
    summaryCount: "{count} lock selected | {count} locks selected",
    emptySelection: "No locks selected",
    saving: "Saving...",
    save: "Save locks for this property",
  },
  gateway: {
    with: "With Gateway",
    without: "No Gateway",
  },
  pms: {
    title: "Control and assignment (PMS)",
    subtitleP1: "Assign each lock to ",
    subtitleStrongMain: "Main door",
    subtitleP2: " or ",
    subtitleStrongUnit: "Unit",
    subtitleP3: ".",
    assignedCount: "{count} assigned | {count} assigned",
    empty: "You don't have any saved locks for this property yet.",
    assignmentLabel: "Assignment",
    assignmentNone: "Unassigned",
    assignmentCommon: "Main door (shared)",
    assignmentUnit: "Apartment door",
    hintNone: "It won't be controlled from the PMS.",
    hintAssigned: "It will be linked to this property for control/PINs.",
    unitLabel: "Unit / Accommodation",
    unitSelectPlaceholder: "Select a unit",
    unitHint: "Select which unit this lock opens.",
    nameLabel: "Name (optional)",
    namePlaceholder: "e.g. Main door / Apt 101",
    saving: "Saving...",
    save: "Save assignment",
  },
  actions: {
    lock: "Lock",
    unlock: "Unlock",
    requiresGateway: "Requires Gateway",
    createPasscode: "Create passcode",
    passcodeHistory: "Passcode history",
    refreshStatus: "Refresh status",
  },
  lockFallbackName: "Lock {id}",
  unitFallbackName: "Unit {id}",
  history: {
    title: "Passcode history",
    revocationTitle: "About revoking codes:",
    withGatewayLabel: "With gateway:",
    withGatewayText: "The code is revoked immediately on the physical lock.",
    withoutGatewayLabel: "Without gateway:",
    withoutGatewayText:
      "The code is removed from the TTLock server, but it will keep working on the lock until someone connects via Bluetooth from the mobile app and syncs.",
    loading: "Loading history…",
    empty: "No passcodes recorded for this lock.",
    colAlias: "Alias",
    colPasscode: "Passcode",
    colValidity: "Validity",
    colStatus: "Status",
    createdAt: "Created: {date}",
    fromLabel: "From:",
    toLabel: "To:",
    revokedTitle: "Already revoked",
    revokeTitle: "Delete / Revoke passcode",
    close: "Close",
  },
  passcodeModal: {
    title: "Create temporary passcode",
    nameLabel: "Name / Label",
    namePlaceholder: "e.g. Cleaning / Guest / Technician",
    nameHint: "This name will help you identify the code.",
    validFrom: "Valid from",
    validTo: "Valid until",
    importantLabel: "Important:",
    importantText:
      "The code will be generated automatically by TTLock and available only during the specified period. The guest can enter this code directly on the lock keypad (it works without internet).",
    noGatewayLabel: "No Gateway:",
    noGatewayText:
      "This lock has no gateway connected. The generated codes will work perfectly on the physical keypad, but you won't be able to revoke them remotely from this panel. To revoke, you'll have to do it from the TTLock app by connecting via Bluetooth.",
    cancel: "Cancel",
    creating: "Creating...",
    create: "Create passcode",
  },
  states: {
    active: "Active",
    upcoming: "Upcoming",
    expired: "Expired",
    revoked: "Revoked",
    noDate: "No date",
  },
  confirm: {
    revoke:
      'Are you sure you want to revoke/delete the passcode "{alias}"?\n\nNote: If the lock has no gateway, revocation may be only partial.',
  },
  toast: {
    noLocksFound: "No locks found in TTLock.",
    loadStatusError: "Couldn't load lock status",
    loadStatusErrorGeneric: "Error loading lock status",
    credentialsRequired: "You must enter a username and password, or have saved credentials.",
    connectionOk:
      "Connection successful. {count} device found. | Connection successful. {count} devices found.",
    testError: "Error testing the connection",
    credentialsSaved: "Credentials saved successfully",
    saveCredentialsError: "Error saving credentials",
    saveCredentialsErrorDetail: "Error saving credentials: {msg}",
    selectAtLeastOne: "You must select at least one device for this property.",
    devicesSaved: "Devices saved for this property",
    devicesSaveError: "Couldn't save the devices",
    saveErrorDetail: "Error saving: {msg}",
    unitRequired: "Select the unit for the locks assigned as 'Apartment door'.",
    bindingsSaved: "Assignment saved successfully",
    bindingsSaveError: "Couldn't save the assignment",
    bindingsSaveErrorDetail: "Error saving assignment: {msg}",
    assignFirst: "First assign the lock (main door or unit) and save to enable control.",
    passcodeNameRequired: "You must provide a name/label for the passcode.",
    passcodeDatesRequired: "You must provide a valid-from and valid-until.",
    passcodeCreated: "Passcode created: {code}",
    passcodeCreateError: "Couldn't create the passcode",
    passcodeCreateErrorGeneric: "Error creating passcode",
    lockLocked: "Lock locked",
    lockLockError: "Couldn't lock",
    lockLockErrorGeneric: "Error locking",
    lockUnlocked: "Lock unlocked",
    lockUnlockError: "Couldn't unlock",
    lockUnlockErrorGeneric: "Error unlocking",
    revokeNoProviderId: "This passcode has no provider_passcode_id. It can't be revoked in TTLock.",
    revokedOk: "Passcode fully revoked",
    revokeError: "Couldn't revoke",
    revokeErrorGeneric: "Error revoking passcode",
    historyLoadError: "Couldn't load the history",
    historyLoadErrorGeneric: "Error loading history",
  },
};
